import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolGetStartedStepThree = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-5 md:col-span-6 hidden sm:block">
          <Image
            width={310}
            height={256}
            className="flex-image"
            src="/images/book.png"
            alt="book a class image"
          />
        </div>
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.gettingStarted.explanations.title.step2')}
          </h2>
          <div className="block sm:hidden mb-8 mt-8 sm:mb-0 sm:mt-0">
            <Image
              width={310}
              height={256}
              className="flex-image"
              src="/images/book.png"
              alt="book a class image"
            />
          </div>
          <p className="school-section-description">
            {t('service.school.gettingStarted.explanations.detail.step2')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolGetStartedStepThree;
